<template>
  <el-form
    ref="form"
    :label-position="labelPosition"
    :model="form"
    :rules="rules"
    label-width="100px"
  >
    <el-form-item
      label="类型"
      prop="type"
    >
      <el-radio-group
        v-model="form.type"
      >
        <el-radio
          v-for="(type, index) in typeList"
          :label="index"
          :key="index"
        >{{ type }}</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item
      prop="name"
      :label="typeList[form.type] + '名称'"
    >
      <el-input
        placeholder="请输入"
        v-model="form.name"
      ></el-input>
    </el-form-item>
    <el-form-item
      prop="parentName"
      label="上级菜单"
    >
      <el-popover
        ref="menuListPopover"
        placement="bottom-start"
        trigger="click"
      >
        <el-tree
          :data="menuList"
          :props="menuListTreeProps"
          node-key="menuId"
          ref="menuListTree"
          @current-change="menuListTreeCurrentChangeHandle"
          :default-expand-all="true"
          :highlight-current="true"
          :expand-on-click-node="false"
        >
        </el-tree>
      </el-popover>
      <el-input
        v-model="form.parentName"
        v-popover:menuListPopover
        readonly
        placeholder="点击选择上级菜单"
        class="menu-list__input"
      ></el-input>
    </el-form-item>
    <el-form-item
      v-if="form.type === 1"
      label="菜单路由"
      prop="url"
    >
      <el-input
        v-model="form.url"
        placeholder="菜单路由"
      ></el-input>
    </el-form-item>
    <el-form-item
      v-if="form.type !== 0"
      label="授权标识"
      prop="perms"
    >
      <el-input
        v-model="form.perms"
        placeholder="多个用逗号分隔, 如: user:list,user:create"
      ></el-input>
    </el-form-item>
    <el-form-item
      v-if="form.type !== 2"
      label="菜单图标"
      prop="icon"
    >
<!--      <el-input
        v-model="form.icon"
        placeholder="菜单图标名称"
        class="icon-list__input"
      ></el-input>-->
      <el-popover
        placement="bottom-start"
        width="318"
        trigger="click"
        @show="$refs['iconSelect'].reset()"
      >
        <iconSelect ref="iconSelect" @selected="selected" />
        <!--有个图标显示错误 done-->
        <el-input
          slot="reference"
          v-model="form.icon"
          style="width: 318px;display: flex"
          placeholder="点击选择图标"
          :readonly="true"
          clearable
        >
          <icon-svg
            v-if="form.icon"
            slot="prefix"
            :icon-class="form.icon"
            class="el-input__icon"
            style="height: 42px;width: 16px;line-height: 40px;"
          />
          <i v-else slot="prefix" class="el-icon-search el-input__icon"/>
        </el-input>
      </el-popover>
    </el-form-item>
    <el-form-item
      v-if="form.type !== 2"
      label="排序号"
      prop="orderNum"
    >
      <el-input-number
        v-model="form.orderNum"
        controls-position="right"
        :min="0"
        label="排序号"
      ></el-input-number>
    </el-form-item>
  </el-form>
</template>

<script>
import iconSelect from '@/components/public/IconSelect';
import { treeDataTranslate } from '@/utils/common'
import { queryParentMenuList } from '@/api/sys/menu';
import formLabalPosition from "@/mixins/formLabalPosition";
export default {
  name: "menuForm",
  components: {
    iconSelect
  },
  props: {
    menuId:{
    },
    formData:{
      type: Object,
    }
  },
  data() {
    return {
      menuList: [],
      form: {
        type: 0,
        name: '',
        parentId: '',
        parentName: '',
        url: '',
        perms: '',
        icon: '',
        orderNum: '',
      },
      rules: {
        type: [
          { required:true, message: '请选择', trigger: 'change' },
        ],
        name: [
          { required:true, message: '请输入', trigger: 'blur' },
        ],
        parentName: [
          // { required:true, message: '请输入', trigger: 'blur' },
        ],
        url: [
          { required:true, message: '请输入', trigger: 'blur' },
        ],
        perms: [
          // { required:true, message: '请输入', trigger: 'blur' },
        ],
        icon: [
          // { required:true, message: '请输入', trigger: 'blur' },
        ],
        orderNum: [
          // { required:true, message: '请输入', trigger: 'blur' },
        ],
      },
      typeList: ['目录', '菜单', '按钮'],
      menuListTreeProps: {
        label: 'name',
        children: 'children'
      }
    }
  },
  watch:{
    formData:{
      handler(newValue){
        if(newValue.menuId){
          this.assigen(newValue);
        }
      },
      deep: true,
    }
  },
  mixins: [formLabalPosition],
  created(){
    this.getParentMenuSelectList();
  },
  methods: {
    getParentMenuSelectList(){
      queryParentMenuList().then((data) => {
        this.menuList = treeDataTranslate(data.menuList, 'menuId')
      })
    },

    assigen(menu){
      this.form.id = menu.menuId;
      this.form.type = menu.type;
      this.form.name = menu.name;
      this.form.parentId = menu.parentId;
      this.form.url = menu.url;
      this.form.perms = menu.perms;
      this.form.orderNum = menu.orderNum;
      this.form.icon = menu.icon;
      this.menuListTreeSetCurrentNode()
    },
    // 菜单树设置当前选中节点
    // 上级菜单有时候编辑的时候没有对得上,有点问题, todo
    menuListTreeSetCurrentNode() {
      this.$refs.menuListTree.setCurrentKey(this.form.parentId);
      this.form.parentName = (this.$refs.menuListTree.getCurrentNode() || {})['name']
    },
    selfValidate() {
      this.$refs.form.validate((valid) => {
        if(valid){
          this.$emit('submit',this.form);
        }
      })
    },
    selfClear(){
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
    },
    menuListTreeCurrentChangeHandle(data,node){
      this.form.parentId = data.menuId
      this.form.parentName = data.name
    },
    selected(name) {
      this.form.icon = name;
    },
  },
}
</script>

<style scoped>

</style>
